"use client";

import { useState, useEffect } from "react";

export function useIsDomReady() {
  const [isDomReady, setIsDomReady] = useState(false);

  useEffect(() => {
    const updateState = () => {
      setIsDomReady(true);
    };

    if (document.readyState === "complete") {
      updateState();
    } else {
      window.addEventListener("load", updateState);
    }

    return () => window.removeEventListener("load", updateState);
  }, []);

  return isDomReady;
}
